import { ActionContext } from 'vuex';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import leadsCombined from '@/shared/services/leads-combined';
import {
  IApiResponse, IMetaResponse, ILeadsCombined,
} from '@/shared';

export default {
  namespaced: true,
  state: {
    list: undefined,
    single: undefined,
  },
  getters: {
    list: (state: any): ILeadsCombined[] => state.list?.data || [],
    single: (state: any): ILeadsCombined => ({ ...state.single?.data || {} }),
    total: (state: any): number => {
      if (!state.list || !state.list.meta) return 0;
      return state.list.meta.totalRecords;
    },
  },
  mutations: {
    set: (state: any, payload: IApiResponse<ILeadsCombined[], IMetaResponse>) => {
      const { meta: oldMeta, data: oldData } = state.list;
      const { meta: newMeta, data: newData } = payload;
      if (!newMeta || !newData) return;
      if (!oldMeta || !oldData) {
        state.list = payload;
      } else if (oldMeta.currentPage < newMeta.currentPage) {
        state.list = {
          data: [...oldData, ...newData],
          meta: newMeta,
        };
      } else {
        state.list = {
          data: newData,
          meta: newMeta,
        };
      }
    },
    reset: (state: any) => {
      state.list = [];
      state.single = null;
    },
  },
  actions: {
    get: async (ctx: ActionContext<any, any>, payload: IQueryCommandOptions) => {
      const { data, meta } = ctx.state.list;
      if (!data || !meta || (payload.page && payload.page < meta.totalPages + 1)) {
        const result = await leadsCombined.get(payload);
        ctx.commit('set', result);
      }
      // }
    },
  },
};
